import React, {useState} from 'react';
import {TableLineLoader} from "../../front/loader/TableLineLoader";
import DateService from "../../../service/DateService";
import {NavLink} from "react-router-dom";
import {ApiService} from "../../../service/ApiService";
import {DeleteConfirme} from "../DeleteConfirme";
import {document} from "../../../models/document";
import {documentHydrator} from "../../../models/hydrator/documentHydrator";
import {scrollTo} from "../../../service/ToolsService";

type DocumentListProp = {
  documents: document[],
  loading?: boolean,
  refresh: () => void,
}

export const DocumentList = ({documents, loading, refresh}: DocumentListProp) => {
  const [del, setDel] = useState(undefined as undefined | document);

  const deleteDocument = async (document: document) => {
    await ApiService.delete(`/document/${document.documentId}`);
    refresh();
  };

  return (
    <>
      <table className="table table-responsive table-hover border">
        <thead>
        <tr className="table-primary">
          <th>Nom</th>
          <th className="text-center w80px">Fichier</th>
          <th className="text-center w80px">Nouvelle ligne</th>
          <th className="text-center w80px">Visible</th>
          <th className="text-center w150px d-lg-table-cell d-none">Modification</th>
          <th className="w190px"></th>
        </tr>
        </thead>
        <tbody>
        {loading && (
          <tr>
            <td colSpan={6} className="pt-4 pb-4 ps-5 pe-5">
              <TableLineLoader/>
            </td>
          </tr>
        )}

        {!loading && documents.map((d: document, i: number) => (
          <tr key={i} className="align-middle">
            <td>{d.label}</td>
            <td className="text-center">
              <a href={documentHydrator.downloadUrl(d)} target="_blank" rel="noreferrer"><i className="fa-regular fa-file-pdf"/></a>
            </td>
            <td className="text-center">{d.lineBreak && (<i className="fa-solid fa-arrow-turn-down"/>)}</td>
            <td className="text-center">{d.enabled && (<i className="fa-solid fa-eye"/>)}</td>
            <td className="text-center d-lg-table-cell d-none">
              {DateService
                .toLocaleString(d.updatedAt ?? d.createdAt, {day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false})
              }
            </td>
            <td className="text-end">
              <NavLink to={`/admin/document/edit/${d.documentId}`} onClick={scrollTo} className="btn btn-xs btn-primary me-1">
                <i className="fa-solid fa-pencil me-1"/> modifier
              </NavLink>
              <button className="btn btn-xs btn-danger" onClick={() => setDel(d)}><i className="fa-solid fa-xmark me-1"/>supprimer</button>
            </td>
          </tr>
        ))}
        </tbody>
      </table>
      {del && (
        <DeleteConfirme confirme={(c: boolean) => {
          if (c) {
            deleteDocument(del);
          }

          setDel(undefined);
        }}/>
      )}
    </>
  );
}
